var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersDarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Team_bue",
    "data-name": "My Team_bue",
    transform: "translate(-10027 781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My_Team_gray",
    "data-name": "My Team_gray",
    transform: "translate(10027 -781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160890",
    "data-name": "Group 160890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140092",
    "data-name": "Rectangle 140092",
    width: 12,
    height: 12,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "users-svgrepo-com_2_",
    "data-name": "users-svgrepo-com (2)",
    transform: "translate(-2.203 -4.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M15.631,7.09a1.449,1.449,0,1,1,0,2.719",
    transform: "translate(-5.093 -0.42)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M3,17.739C3.4,16.4,4.432,16,6.768,16s3.368.4,3.768,1.739",
    transform: "translate(0 -4.203)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M17,15c1.393.055,2.046.37,2.319,1.159",
    transform: "translate(-5.884 -3.782)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M10.058,8.029A2.029,2.029,0,1,1,8.029,6,2.029,2.029,0,0,1,10.058,8.029Z",
    transform: "translate(-1.261 0)",
    fill: "none",
    stroke: "#2d68fe",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersDarkIcon);
export default __webpack_public_path__ + "static/media/users-dark-icon.43c195cfe769b7e038ca84b83f4eb3aa.svg";
export { ForwardRef as ReactComponent };